import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { EditQuizManagementSlice, UpdateStatusQuizManagementSlice } from "../../../../redux/features/Quiz Management/QuizManagementByManual";
import { ListquizcategorySlice } from "../../../../redux/features/Quiz Management/QuizCategory";

const ViewQuizByApi = () => {
  const { state } = useLocation();
  const [iState, setUpdate] = useState([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [categoryList, setCategoryList] = useState([]);

  useEffect(() => {
    console.log(state);
    setUpdate(state);
  }, [state]);

  const updateStatusQuiz = ({ id, status }) => {
    const data = {
      status: status,
      isActive: true,
    };

    dispatch(UpdateStatusQuizManagementSlice({ id, data }))?.then((res) => {
      if(res?.payload?.customStatus === 200){
        console.log(res);
        navigate("/QuizManagement/QuizUploadByApi/AllPublishedQuizByApi");
      }
    });
  };

  useEffect(() => {
    dispatch(ListquizcategorySlice()).then((res) => {
      if (res?.payload?.customStatus === 200) {
        setCategoryList(res.payload?.data);
      }
    });
  }, []);

  const hanldeCategoryChange = (e) => {
    console.log("iState:",iState)
    dispatch(EditQuizManagementSlice({ id: iState?._id, data: iState }))?.then(
            (res) => {
              if (res?.payload?.customStatus === 200) {
                navigate(-1);
              }
            }
          );
  };

  return (
    <>
      <div className="WrapperBox">
        <div className="TitleBox">
          <h4 className="Title">Quiz Management</h4>
          <span>
            <a className="TitleLink" onClick={() => navigate(-1)}>
              <i className="fa fa-arrow-left" />
              Back
            </a>
          </span>
        </div>
        <div className="Small-Wrapper">
          <div className="CommonForm">
            <h4>View Quiz</h4>
            <div className="row">
              <div className="col-4">
                {" "}
                <div className="form-group">
                  <label>Quiz Category</label>
                {iState?.status==="pending"?(
                  <select
                  name="quizcategory"
                  id="quizcategory"
                  className="form-control"
                  value={iState?.quizDetail?.quizcategory || ""}
                  onChange={(event) => {
                    const value = event?.target?.value;
                    console.log("value:", value);
                    setUpdate((prev) => ({
                      ...prev,
                      quizDetail: { ...prev["quizDetail"], quizcategory: value },
                    }));
                  }}
                >
                  <option value="">Select</option>
                  {categoryList?.map((item, index) => (
                    <option key={index} value={item?.categoryName}>
                      {item?.categoryName}
                    </option>
                  ))}
                </select>
                ):(
                  <input
                    type="text"
                    disabled
                    value={iState?.quizDetail?.quizcategory}
                    className="form-control"
                  />)}
                </div>
              </div>
              <div className="col-4">
                {" "}
                <div className="form-group">
                  <label>Level</label>
                  <input
                    type="text"
                    disabled
                    value={iState?.quizDetail?.level}
                    className="form-control"
                  />
                </div>
              </div>
              <div className="col-4">
                {" "}
                <div className="form-group">
                  <label>Choose Number of Questions</label>
                  <input
                    type="text"
                    className="form-control"
                    value={iState?.questionDetail?.length || 0}
                    disabled
                  />
                </div>
              </div>
              <div className="col-4">
                {" "}
                <div className="form-group">
                  <label>Number of options for Answers</label>
                  <input
                    type="text"
                    disabled
                    value={iState?.quizDetail?.optionsforanswers}
                    className="form-control"
                  />
                </div>
              </div>
              <div className="col-4">
                {" "}
                <div className="form-group">
                  <label>Duration</label>
                  <input
                    type="text"
                    disabled
                    value={iState?.quizDetail?.duration + " min"}
                    className="form-control"
                  />
                </div>
              </div>
              <div className="col-4">
                {" "}
                <div className="form-group">
                  <label>Question Paper Name</label>
                  <input
                    type="text"
                    disabled
                    value={iState?.quizDetail?.papername}
                    className="form-control"
                  />
                </div>
              </div>
            </div>

            <div className="Small-Wrapper">
              {iState?.questionDetail?.map((item, index) => {
                const optionData = Object.entries(item);
                return (
                  <>
                    <div className="row">
                      <div className="col-12">
                        <div className="form-group">
                          <label>Question {index + 1}</label>
                          <input
                            type="text"
                            name="question"
                            className="form-control"
                            value={item?.question}
                            disabled
                            placeholder="The bacterium Arobacterium tumeficians is used to obtain which of the following ?"
                          />
                        </div>
                      </div>{" "}
                      {optionData?.map(([key, value], i) => {
                        if (
                          ![
                            "hint",
                            "optionanswer",
                            "question",
                            "_id",
                          ]?.includes(key)
                        ) {
                          return (
                            <>
                              <div className="col-4">
                                <div className="form-group">
                                  <label>Option {i}</label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Bt-toxin"
                                    value={value}
                                    disabled
                                  />
                                </div>
                              </div>
                            </>
                          );
                        }
                      })}
                      <div className="col-4">
                        <div className="form-group">
                          <label>Choose options for Answers</label>
                          <input type="text" disabled value={item?.optionanswer} className="form-control"/>
                        </div>
                      </div>
                      <div className="col-4">
                        <div className="form-group">
                          <label>Hint</label>
                          <input type="text" disabled value={item?.hint} className="form-control"/>

                        </div>
                      </div>
                    </div>
                    {index !== iState?.questionDetail?.length - 1 && (
                      <div
                        style={{
                          border: "1px solid black",
                          width: "100%",
                          margin: "20px 0",
                        }}
                      ></div>
                    )}
                  </>
                );
              })}
            </div>
          </div>
          {iState?.status==="pending" &&(
<div style={{display:"flex",gap:'10px'}}>
      <button
        style={{
          backgroundColor: "#e3083f",
          color: "white",
          height: "40px",
          width: "90px",
          border: "none",
          borderRadius: "5px",
          marginTop: "10px",
        }}
        onClick={()=>updateStatusQuiz({id:iState?._id,status:"published"})}
      >
        Publish
      </button>
      <button
      style={{
        backgroundColor: "#e3083f",
        color: "white",
        height: "40px",
        width: "90px",
        border: "none",
        borderRadius: "5px",
        whiteSpace:"nowrap",
        width:"fit-content",
        padding:"0 10px",
        marginTop: "10px",
      }}
      onClick={hanldeCategoryChange}>
        Update category
      </button>
  </div>    
    )
      
      }
        </div>
      </div>
    </>
  );
};

export default ViewQuizByApi;
